import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PostSideBar from "./QuestionSideBar";
import { askQuestionUrl, currentUser } from "./questionHelpers";
import "./questions.css";

export default function SideBar() {
  const { t } = useTranslation();
  const user = currentUser();
  return (
    <aside className="col-lg-4 col-md-12">
      <div className="avc-qa-aside">
        {user?.role !== "lawyer" && (
          <div className="avc-ask-card">
            <span className="avc-ask-card__icon">
              <i className="far fa-comments" aria-hidden="true"></i>
            </span>
            <h2 className="avc-ask-card__title">{t("contact_question_title")}</h2>
            <p className="avc-ask-card__text">{t("qa_ask_text")}</p>
            <Link to={askQuestionUrl()} className="avc-btn avc-btn--gold avc-btn--block">
              <i className="far fa-edit" aria-hidden="true"></i>
              {t("qa_ask")}
            </Link>
          </div>
        )}
        <PostSideBar />
      </div>
    </aside>
  );
}
